<div class="modal-backdrop-custom" (click)="cancel()">
  <div #modalBox 
       class="modal-box" 
       (click)="$event.stopPropagation()"
       role="dialog"
       aria-modal="true"
       aria-labelledby="modal-title">

    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title-wrapper">
        <h4 class="modal-title" id="modal-title">Select Person</h4>
      </div>
      <button type="button" 
              class="modal-close-btn" 
              (click)="cancel()" 
              aria-label="Close modal">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body" role="region" aria-label="Person selection table">
      <app-data-table
  [columns]="columns"
  [data]="allPeople"
  [serverSide]="true"
  [totalRecords]="caseService.personsTotalRecords()"
  [page]="caseService.personsCurrentPage()"
  [trackBy]="getSelectionKey"
  [isSelected]="isSelected"
  [showCheckbox]="true"
  [filterable]="true"
  filterPlaceholder="Type to filter..."
  [showPagination]="true"
  [pageSizeOptions]="[10, 25, 50, 100]"
  [defaultPageSize]="10"
  maxHeight="220px"
  emptyMessage="No matching records found"
  (rowClick)="toggleSelect($event)"
  (pageOrSizeChange)="onPageOrSizeChange($event)">
</app-data-table>
    </div>

    <!-- Footer buttons -->
    <div class="modal-footer">
      <button class="btn-cancel" (click)="cancel()" aria-label="Cancel selection">Cancel</button>
      <button class="btn-save" (click)="save()" aria-label="Save selected persons">Save</button>
    </div>

  </div>
</div>